/** *
 * 药商管理、药房管理、药品管理
 */
import Main from '@components/main/main'

const pharmacyManageRouter = {
  path: '/pharmay',
  component: Main,
  children: [{
    name: 'pharmacist',
    path: '/pharmacist',
    component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/list'], resolve),
    meta: {
      auth: true,
      title: '药商管理'
    }
  },
  {
    name: 'pharmacistConfigure',
    path: '/pharmacist/configure',
    redirect: '/pharmacist/dealBasic',
    component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/configure'], resolve),
    meta: {
      auth: true,
      title: '药商配置'
    },
    children: [
      {
        name: 'dealBasic',
        path: '/pharmacist/dealBasic',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/dealBasic'], resolve),
        meta: {
          auth: true,
          title: '基本信息'
        }
      },
      {
        name: 'dealRole',
        path: '/pharmacist/dealRole',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/dealRole'], resolve),
        meta: {
          auth: true,
          title: '角色管理'
        }
      },
      {
        name: 'dealAccount',
        path: '/pharmacist/dealAccount',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/dealAccount'], resolve),
        meta: {
          auth: true,
          title: '账号管理'
        }
      },
      {
        name: 'pharmacistDrugList',
        path: '/pharmacist/pharmacistDrugList',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/drugList'], resolve),
        meta: {
          auth: true,
          title: '药商药品'
        }
      },
      {
        name: 'hospitalDrugAssociation',
        path: '/pharmacist/hospitalDrugAssociation',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/hospitalDrugAssociation'], resolve),
        meta: {
          auth: true,
          title: '医院药品关联'
        }
      },
      {
        name: 'pharmacistDrugDetails',
        path: '/pharmacist/pharmacistDrugDetails',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/drugDetails'], resolve),
        meta: {
          auth: true,
          title: '药商药品'
        }
      },
      {
        name: 'synchronousHospitalDrag',
        path: '/pharmacist/synchronousHospitalDrag',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/synchronousHospitalDrag'], resolve),
        meta: {
          auth: true,
          title: '药商药品'
        }
      },
    ]
  },
  {
    name: 'pharmacistSetRole',
    path: '/pharmacist/roleEdit',
    component: resolve => require(['@pages/pharmacyManage/pages/pharmacist/roleEdit'], resolve),
    meta: {
      auth: true,
      title: '角色编辑'
    }
  },
  {
    name: 'pharmacyManagement',
    path: '/pharmacy',
    component: resolve => require(['@pages/pharmacyManage/pages/pharmacy/list'], resolve),
    meta: {
      auth: true,
      title: '药房管理'
    }
  },
  {
    name: 'pharmacyConfigure',
    path: '/pharmacy/configure',
    redirect: '/pharmacy/storeBasic',
    component: resolve => require(['@pages/pharmacyManage/pages/pharmacy/configure'], resolve),
    meta: {
      auth: true,
      title: '药房配置'
    },
    children: [
      {
        name: 'storeBasic',
        path: '/pharmacy/storeBasic',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacy/storeBasic'], resolve),
        meta: {
          auth: true,
          title: '基本信息'
        }
      },
      {
        name: 'storeDrugs',
        path: '/pharmacy/storeDrugs',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacy/storeDrugs'], resolve),
        meta: {
          auth: true,
          title: '药品目录'
        }
      },
      {
        name: 'newsDrugs',
        path: '/pharmacy/newsDrugs',
        component: resolve => require(['@pages/pharmacyManage/pages/pharmacy/newsDrugs'], resolve),
        meta: {
          auth: true,
          title: '新增药品'
        }
      }
    ]
  },
  {
    name: 'pharmacyNewStore',
    path: '/pharmacy/newStore',
    component: resolve => require(['@pages/pharmacyManage/pages/pharmacy/newStore'], resolve),
    meta: {
      auth: true,
      title: '新增药房'
    }
  },
  {
    name: 'pharmacyDetail',
    path: '/pharmacy/detail',
    component: resolve => require(['@pages/pharmacyManage/pages/pharmacy/detail'], resolve),
    meta: {
      auth: true,
      title: '药房信息'
    }
  }]
}

export default pharmacyManageRouter



// WEBPACK FOOTER //
// ./src/pages/pharmacyManage/index.js